import type { Domains } from "@/direct-access";
import { AppKeys } from "@/direct-app-config";

/** 組織選択ドロップダウンの項目の表示状態 */
export type DomainItemState =
  /** 掲示板が利用できない組織。グレー表示＋警告文でクリック不可 */
  | "off"
  /** 選択中の組織 */
  | "selected"
  /** 上記以外 */
  | "normal";

/** @return true: 掲示板がON false: 掲示板がOFF */
export const isForumEnabled = (domain: Domains[number]): boolean => {
  const keys: string[] = domain?.contract?.direct_app_keys || [];
  return keys.includes(AppKeys.FORUM);
};

/**
 * ドロップダウン項目の表示状態を返す。
 * 表示中の組織が direct 運用ツールで掲示板OFFにされる場合があるため、
 * 選択中かどうかより掲示板の有効/無効を優先して判定する。
 */
export const domainItemState = (
  domain: Domains[number],
  selectedDomainId: string,
): DomainItemState => {
  if (!isForumEnabled(domain)) return "off";
  if (domain.domain_id_str === selectedDomainId) return "selected";
  return "normal";
};
